module.exports = __webpack_public_path__ + "img/white.38be7ee0.jpg";